<template>
  <div class="list-main-container">
    <zs-fixed-share></zs-fixed-share>

    <div class="list-detail-box">
      <!-- 左侧悬浮按钮 -->
      <zs-right-banner :gameInfo="gameInfo" />
      <div class="list-container">
        <!-- 顶部搜索 -->
        <div>
          <!-- 搜索栏 -->
          <div class="search-top-line">
            <input v-model="keyword" type="text" class="search-input" @keyup.enter="onSearch" />
            <el-button
              type="primary"
              class="search-btn"
              @click="onSearch"
              :style="
                theme
                  ? {
                      backgroundColor: theme.highlightBtnBg,
                      color: theme.highlightBtnColor
                    }
                  : {}
              "
              >搜索</el-button
            >
          </div>
          <!-- 标签检索栏 -->
          <div class="list-nav-box" :style="{ padding: !isSearch ? 0 : null, border: !isSearch ? 'none' : null }">
            <div class="list-nav" v-if="isSearch">
              <div
                v-for="(item, index) in typeActive"
                :key="index"
                :class="activeType === item.type ? 'active' : ''"
                class="list-nav-a"
                :style="
                  theme && activeType === item.type
                    ? {
                        color: theme.activeTextColor
                      }
                    : {}
                "
                @click="handleBtn(item.type)"
              >
                {{ item.name
                }}<i
                  :style="
                    theme
                      ? {
                          backgroundColor: theme.activeTextColor
                        }
                      : {}
                  "
                ></i>
              </div>
            </div>
            <!-- 默认列表排序 -->
            <el-dropdown @command="onChange" v-if="isSearch">
              <span class="filter-btn">
                <img src="@/assets/images/list-order.png" alt="" />
                {{ orderList[order_by] || "默认排序" }}
              </span>
              <el-dropdown-menu class="zsca2-list-dropdown" slot="dropdown">
                <el-dropdown-item v-for="(item, key) in orderList" :key="key" :command="key">{{
                  item
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- 列表 -->
        <div class="wiki-list">
          <div class="wiki-list-content">
            <!-- 滚动列表 -->
            <div class="list-content" v-show="list.length">
              <scroll-comp ref="scrollComp" :page-load="getAllList">
                <zs-article-item
                  v-for="item in list"
                  :key="item.id"
                  :item="item"
                  :keyword="searchKeyword"
                  layout="column"
                ></zs-article-item>
              </scroll-comp>
            </div>
            <!-- 搜索为空 -->
            <div class="search-empty" v-show="isSearch && !list.length">
              <img class="empty-icon" src="@/assets/images/list-search-empty.png" alt="" />
              <div class="tips">暂未搜索到相关的内容</div>
              <div class="other">
                <div class="tips">
                  若您有相关游戏经验或问题，点击“社区留言”，在社区分享或 提问，与其他玩家交流探讨。
                </div>
                <el-button type="primary" class="btn" @click="goEdit">社区留言</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// components
import zsArticleItem from "./components/zsArticleItem.vue";
import ScrollComp from "@/components/Scroll";
import ZsFixedShare from "@/views/wiki/components/zsFixedShare";
import ZsRightBanner from "@/views/wiki/components/zsRightBanner";
// plugins
// import eventBus from "@/plugins/eventBus";
// api
import { apiContentTopList } from "@/api/contentApi";
// mixins
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

// 分词
// function splitWord(kw = "") {
//   // 按照空格分词
//   const kwList = kw.split(" ");
//   // 去除空格
//   return kwList.filter(item => item);
// }

export default {
  name: "wikiList",
  mixins: [mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    ScrollComp,
    zsArticleItem,
    ZsFixedShare,
    ZsRightBanner
  },
  data() {
    return {
      typeActive: [
        {
          type: "",
          name: this.$t("all")
        },
        {
          type: "17",
          name: this.$t("question")
        },
        {
          type: "4",
          name: this.$t("posts")
        },
        {
          type: "1",
          name: this.$t("entrys")
        },
        {
          type: "2",
          name: this.$t("notices")
        },
        {
          type: "15",
          name: this.$t("strategy")
        }
      ],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      activeType: "4,17", // 默认取帖子类型
      keyword: "",
      searchKeyword: "",
      order_by: "updated_at",
      orderList: {
        created_at: "最新发帖",
        updated_at: "最近更新",
        comment_at: "最新回复",
        default: "默认排序"
      },
      isSearch: false,
      list: [],
      topList: [],
      isSSRGetData: false,
      isScroll: false,
      timer: null
    };
  },
  async asyncData({ store, router, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      // TDK设置
      const gameInfo = store.getters.gameInfo;
      ssrContext.title = `${gameInfo.name}论坛社区_${gameInfo.name}wiki|GameKee`;
      ssrContext.keywords = `${gameInfo.name}论坛,${gameInfo.name}社区`;
      ssrContext.description = `${gameInfo.name}wiki的${gameInfo.name}论坛版块为${gameInfo.name}玩家们提供互相交流的平台，快来加入${gameInfo.name}社区吧！`;
      // 数据预取
      const { query } = router.currentRoute;
      let activeType = query.tab || ""; // 默认
      const keyword = query.kw || "";
      let isSearch = false;
      let searchKeyword = "";
      if (!activeType) {
        if (keyword) {
          isSearch = true;
          activeType = "";
          searchKeyword = keyword;
        } else {
          activeType = "4,17";
        }
      }
      // const params1 = {
      //   limit: 3,
      //   type: "2"
      // };
      let pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      const params2 = {
        ...pagination,
        type: activeType,
        order_by: "updated_at",
        keyword: searchKeyword
      };
      const resList = await Promise.all([
        // $apis.apiContentList(params1),
        $apis.apiContentTopList(params2)
      ]);

      let topList = [];
      // if (resList[0].code == 0 && resList[0].data) {
      //   topList = resList[0].data;
      // }
      let list = [];

      if (resList[0].code == 0) {
        list = resList[0].data;
        pagination = resList[0].meta.pagination;
      }
      console.log("asyncData end");
      // console.log(list)
      return {
        topList,
        list,
        pagination,
        keyword,
        searchKeyword,
        isSearch,
        activeType,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapGetters(["loginUser", "gameInfo"])
  },
  methods: {
    goEdit() {
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    onChange(command) {
      console.log(command);
      this.order_by = command == "default" ? "" : command;
      this.reset();
    },
    // 切换分类，清空滚动状态
    handleBtn(type) {
      this.activeType = type;
      this.reset();
    },
    getAllList() {
      let { pagination, $refs, activeType } = this;
      if (!["wikiListNew"].includes(this.$route.name)) return;
      // 达到最大页数后，不触发翻页方法；
      // console.log(pagination)
      if (pagination.page_no >= pagination.page_total) {
        $refs.scrollComp.loadStatus = "end";
        return;
      }
      ++pagination.page_no;
      if (activeType == "2") {
        pagination.limit = 20;
      }
      const params = {
        ...pagination,
        type: this.activeType,
        order_by: this.order_by
      };
      if (this.searchKeyword) {
        params.keyword = this.searchKeyword;
      }
      $refs.scrollComp.loadStatus = "loading";
      apiContentTopList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data || []);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          $refs.scrollComp.loadStatus = "";
        });
    },

    onSearch() {
      if (this.keyword) {
        this.isSearch = true;
        this.searchKeyword = this.keyword;
        // 搜索全部
        this.activeType = "";
        window.staticFn.customEvent("user_search", { value: this.keyword });
      } else if (this.$route.query.tab) {
        this.searchKeyword = "";
        this.activeType = this.$route.query.tab;
        this.isSearch = false;
      } else {
        this.searchKeyword = "";
        this.activeType = "4,17";
        this.isSearch = false;
      }

      this.reset();
    },
    setSearchKw() {
      this.keyword = this.$route.query.kw || "";
      this.searchKeyword = this.keyword;
      this.activeType = this.$route.query.tab || "4,17";
      this.list = [];
      this.isSearch = !!this.$route.query.kw;
      if (!this.list.length) {
        this.reset();
      }
    },
    // 重置分页状态等
    reset() {
      this.pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      this.$refs.scrollComp.loadStatus = "";
      this.list = [];
      this.getAllList();
    },
    handleScroll() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (!this.isScroll) {
        this.isScroll = true;
      }
      this.timer = setTimeout(() => {
        this.isScroll = false;
      }, 100);
    }
  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    if (!this.isSSRGetData) {
      this.setSearchKw();
    }
  },
  updated() {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed() {}
};
</script>

<style lang="less" scoped>
.list-main-container {
  min-height: 100vh;
  // background: var(--zs-qz-bg-img) 50% 0px / cover no-repeat fixed;

  .list-detail-box {
    width: 1216px;
    margin: 0 auto;
    min-height: 100%;
    padding: 13px 10px;
    border-radius: 12px;
    background-color: var(--zs-wiki-home-main-bg);
    .list-container {
      width: 100%;
      padding: 40px 205px;
      border-radius: 12px;
      box-sizing: border-box;
      background-color: var(--zs-search-list-container-bg);
      .search-top-line {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 4px;
        .search-input {
          flex: 1;
          height: 40px;
          padding: 0 6px;
          outline: none;
          border: none;
          box-sizing: border-box;
          color: var(--zs-search-input-text-color);
          border-radius: 4px;
          background-color: var(--zs-search-input-bg-color);
        }
        .search-btn {
          flex: 0 0 auto;
          height: 40px;
          width: 155px;
          margin-left: 16px;
          font-size: 20px;
          border: none;
          color: var(--zs-search-btn-text-color);
          background-color: var(--zs-search-btn-bg-color);
        }
      }

      .list-nav-box {
        position: relative;
        padding: 16px 0;
        margin-bottom: 30px;
        border-bottom: 1px solid var(--zs-search-nav-border-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        /deep/ .el-dropdown {
          position: absolute;
          right: 0;
          font-size: 13px;
          .filter-btn {
            display: flex;
            align-items: center;
            gap: 5px;
            cursor: pointer;
            img {
              width: 16px;
              height: 16px;
            }
          }
        }

        .list-nav {
          display: flex;

          .list-nav-a {
            font-size: 14px;
            color: var(--zs-search-nav-text-color);
            border: 1px solid transparent;
            position: relative;
            margin-right: 64px;
            cursor: pointer;
            display: flex;
            align-items: center;

            i {
              display: none;
              width: 30px;
              height: 3px;
              border-radius: 2px;
              background: var(--zs-search-nav-active-color);
              position: absolute;
              left: 50%;
              bottom: -19px;
              margin-left: -15px;
            }

            &.active {
              color: var(--zs-search-nav-active-color);
              font-weight: 500;

              i {
                display: block;
              }
            }

            &.mar {
              margin: 0 52px;
            }
          }
        }
      }

      .wiki-list {
        display: flex;
        align-items: flex-start;
        position: relative;
        width: 100%;

        .wiki-list-content {
          width: 100%;
          min-height: 500px;
          border-radius: 6px;
          margin-bottom: 20px;
        }

        .list-content {
          width: 100%;
        }
        .search-empty {
          width: 364px;
          margin: 0 auto;
          padding-top: 57px;
          text-align: center;
          .empty-icon {
            width: 180px;
            height: 173px;
            margin-bottom: 9px;
          }

          .tips {
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 21px;
            margin-bottom: 31px;
          }

          .other {
            text-align: center;
            .tips {
              font-weight: 400;
              font-size: 13px;
              color: #787878;
              line-height: 18px;
              margin-bottom: 40px;
              text-align: center;
            }
            .btn {
              width: 155px;
              height: 40px;
              font-size: 20px;
              border: none;
              color: #ffffff;
              background-color: var(--zs-search-empty-btn-bg);
            }
          }
        }
      }
    }
  }
}
.zsca2-list-dropdown {
  padding: 0 15px;
  background-color: var(--zs-search-dropdown-bg);
  border: none;
  /deep/.popper__arrow {
    border-bottom-color: var(--zs-search-dropdown-arrow-bg);
    &:after {
      border-bottom-color: var(--zs-search-dropdown-arrow-bg) !important;
    }
  }
  .el-dropdown-menu__item {
    padding: 0;
    color: #666;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      color: #666;
      background-color: var(--zs-search-dropdown-arrow-bg);
    }
  }
}
</style>
